export function isPreviewable(contentType){return contentType==='application/pdf';}